import React from 'react';
import { bannerIconData } from './banner-icons-data';
import { SVG } from '@at/design-system-elements';
export var BannerIcon = function (_a) {
    var _b;
    var _c = _a.variation, variation = _c === void 0 ? 'default' : _c;
    var result = bannerIconData.bannerIcon.filter(function (item) { return item.name === variation; });
    return (React.createElement(SVG, { title: (_b = result[0].name) !== null && _b !== void 0 ? _b : '', key: result[0].name, svgContent: result[0].svg, height: result[0].svgHeight, width: result[0].svgWidth }));
};
